import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_USER_TODOS } from '@/lib/constants/api'
import getTodoModel from './models/todo'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const todo = {
  namespaced: true,
  state: {
    ...getTodoModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearTodo: (state) => {
      state.id = null
      state.name = null
      state.description = null
      state.linkUrl = null
      state.todoGroupId = null
      state.todoGroupName = null
      state.assignedToUserId = null
      state.targetDate = null
      state.complete = null
      state.completedAt = null
      state.completedBy = null
      state.createdBy = null
      state.updatedBy = null
      state.createAt = null
      state.updatedAt = null
    },
    setTodo: (state, todo) => {
      state.id = todo.id
      state.name = todo.name
      state.description = todo.description
      state.linkUrl = todo.linkUrl
      state.todoGroupId = todo.todoGroupId
      state.todoGroupName = todo.todoGroupName
      state.assignedToUserId = todo.assignedToUserId
      state.targetDate = todo.targetDate
      state.complete = todo.complete
      state.completedAt = todo.completedAt
      state.completedBy = todo.completedBy
      state.createdBy = todo.createdBy
      state.updatedBy = todo.updatedBy
      state.createAt = todo.createdAt
      state.updatedAt = todo.updatedAt
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_USER_TODOS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_USER_TODOS, data: state })
    },
    getTodo: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting task, please wait...' })

      return api.doGet({ path: PATH_USER_TODOS, parameters: { id } })
        .then(json => json.data)
        .then(todo => {
          commit('setTodo', todo)
          commit('updateStatus', { status: COMPLETE })
          hideProgressModal({ dispatch })

          return todo
        }).catch((error) => {
          hideProgressModal({ dispatch })
          commit('updateStatus', { status: ERROR, error })
        })
    },
    saveTodo: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving task, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        if (!response.data) {
          if (response.errorMessage) {
            throw new Error(response.errorMessage)
          }
          throw new Error('Unable to save task. Check required fields.')
        }

        commit('clearTodo')
        commit('updateStatus', { status: COMPLETE })
        hideProgressModal({ dispatch })
        notifySuccess(dispatch, 'Task saved')

        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        hideProgressModal({ dispatch })
        notifyError(dispatch, error || 'Unable to save task. Try again later')
        throw error
      })
    },
    clearTodo: ({ commit }) => {
      commit('clearTodo')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default todo
